module.exports = __webpack_public_path__ + "static/media/colourOptions3-min.107a4e8b.JPG";